

import React, { Component } from "react";
import { withRouter } from "./withRouter";
import  {   Popup } from "react-map-gl";

class NZ2026HomeTooltip extends Component {
 
buildTooltip(hoverInfo, styledGeo,tooltip_pastcomp) {
  const { geoLevel } = this.props; // 👈 bring it in
  if (!hoverInfo) return null;
  if (!styledGeo) return null;
  const { area_name, area_id } = hoverInfo.props;

  // Find matching feature in styledGeo
  const comparatorFeature = styledGeo.features.find(
    f => f.properties.area_id === area_id
  );

  // Predicted vote shares (current prediction)
  const predictedValues = JSON.parse(hoverInfo.props._allValuesSorted);


const partyConfig = {
  // GE / LE vote intention (proportions)
  D66_GE_p: { label: "D66", color: "#2cc800" },
  PVV_GE_p: { label: "PVV", color: "#043555" },
  VVD_GE_p: { label: "VVD", color: "#0e2783" },
  GLpvdA_GE_p: { label: "GL–PvdA", color: "#920c19" },
  CDA_GE_p: { label: "CDA", color: "#339933" },
  OtherRight_GE_p: { label: "Other right", color: "#7393B3" },
  OtherLeft_GE_p: { label: "Other left", color: "#997570" },
  OtherCentre_GE_p: { label: "Other centre", color: "#999999" },

  D66_LE_p: { label: "D66", color: "#2cc800" },
  PVV_LE_p: { label: "PVV", color: "#043555" },
  VVD_LE_p: { label: "VVD", color: "#0e2783" },
  GLpvdA_LE_p: { label: "GL–PvdA", color: "#920c19" },
  CDA_LE_p: { label: "CDA", color: "#339933" },
  OtherRight_LE_p: { label: "Other right", color: "#7393B3" },
  OtherLeft_LE_p: { label: "Other left", color: "#997570" },
  OtherCentre_LE_p: { label: "Other centre", color: "#999999" },

  // Past vote
  past_vote_CDA: { label: "CDA", color: "#339933" },
  past_vote_D66: { label: "D66", color: "#2cc800" },
  past_vote_DidNotVote: { label: "Did not vote", color: "#94A3B8" }, // not in PARTY_INFO, kept as-is
  past_vote_GLpvdA: { label: "GL–PvdA", color: "#920c19" },
  past_vote_OtherCentre: { label: "Other centre", color: "#999999" },
  past_vote_OtherLeft: { label: "Other left", color: "#997570" },
  past_vote_OtherRight: { label: "Other right", color: "#7393B3" },
  past_vote_PVV: { label: "PVV", color: "#043555" },
  past_vote_VVD: { label: "VVD", color: "#0e2783" },
};



  // Build vote share lines / current predicted value
let voteLines;

  voteLines = predictedValues.find(d => d.key === this.props.chosenParty)?.area_id || 0;


// Get "previous" vote (for comparison)
let vote2023 = 0;

  if (tooltip_pastcomp === "no") {
    // derive past_vote_ key dynamically
    const pastKey = this.props.chosenParty.replace("_GE_p", "").replace("_LE_p", "").replace("past_vote_", "").replace(/^/, "");
    vote2023 = comparatorFeature?.properties?.[pastKey]*100 || 0; // already in %
  } else {
    const pastKey = this.props.chosenParty.replace("_GE_p", "").replace("_LE_p", "").replace("past_vote_", "").replace(/^/, "");
    vote2023 = comparatorFeature?.properties?.[pastKey]*100 || 0; // already in %
  }


// Calculate label and change
let area_type_label;
switch (geoLevel) {
  case "geemente":
    area_type_label = "Gemeente";
    break;
  case "buurt":
    area_type_label = "Buurt";
    break;
  default:
    area_type_label = geoLevel;
    break;
}

// Compute change (difference between predicted and previous)
const change_since23 = (voteLines?.toFixed(0) - vote2023?.toFixed(0));


  return (
    <>
    {voteLines &&(
    <div style={{ fontSize: "13px" }}>
      <strong>{area_name}</strong> {area_type_label}
      <br />
      {partyConfig[this.props.chosenParty].label} vote share: <b>{voteLines.toFixed(0)}</b>% <> {change_since23>0? '+':''}{change_since23}% since 2025</>


    </div>
    )}
    </>
  );
}






 

  render() {    
    const {  styledGeo,  hoverInfo} = this.props;

    return (
            <>  
        { styledGeo && hoverInfo && hoverInfo?.props?.topValue &&(
          <Popup
            longitude={hoverInfo.lon}
            latitude={hoverInfo.lat}
            closeButton={false}
            closeOnClick={false}
            offset={12}
            dynamicPosition={true}
            maxWidth="500px"
          >
            {this.buildTooltip(hoverInfo, styledGeo,this.props.tooltip_pastcomp)}
          </Popup>
        )}
          </>
    )}
    }
    
    export default withRouter(NZ2026HomeTooltip);
    